import { useQuery } from "@tanstack/react-query";
import { mcpClient } from "../../lib/mcp-client";
import type { ListActivityResult } from "../../lib/types";

interface ActivityFilters {
  agentId?: string;
  surface?: string;
  since?: string;
  limit?: number;
  cursor?: string;
}

export function useListActivity(filters: ActivityFilters) {
  return useQuery<ListActivityResult>({
    queryKey: ["v3", "activity", filters],
    queryFn: () => mcpClient.listActivity(filters),
    staleTime: 15_000,
  });
}
